import React from 'react';


/* _frfr-universal-components UNICOMPO UNIVERSAL SMALL ELEMENTS/COMPONENTS */

// UniLink <a> Anchor Hyperlink Link

/*
UniLink
PROPS:
props.email // email address
props.phone // phoen number
props.href // URL
props.targetBlank // open in new tab (new window)
props.download // Causes the browser to treat the linked URL as a download.
props.extraClass //
props.handleClick // handler for HTML onclick attribute
*/

const UniLink = (props) => {
  let cl = 'unicompo-link';
  let download = null;
  let handleClick = null;
  if (props.download === true) {
    download = true;
  }
  if (typeof props.handleClick === 'function') {
    handleClick = props.handleClick;
  }
  let extraClass = '';
  if (typeof props.extraClass === 'string') {
    // extraClass = ' ' + props.extraClass;
    cl += ' ' + props.extraClass;
  }
  if (props.email) {
    cl += ' unicompo-link--email';
    return (<a className={cl} onClick={handleClick} download={download} href={"mailto:" + props.email}>{props.children}</a>);
  }
  if (props.phone) {
    cl += ' unicompo-link--phone';
    return (<a className={cl} onClick={handleClick} download={download} href={"tel:" + props.phone}>{props.children}</a>);
  }
  if (props.href) {
    if (props.targetBlank === true) {
      return (<a className={cl} onClick={handleClick} download={download} target="_blank" rel="noopener noreferrer" href={props.href}>{props.children}</a>);
    } else {
      return (<a className={cl} onClick={handleClick} download={download} href={props.href}>{props.children}</a>);
    }
  }

  return (
    <></>
  );
};

export default UniLink;